import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Long: any;
};

export type Action = {
  __typename?: 'Action';
  key: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  pv: Scalars['Long'];
  total_pv?: Maybe<Scalars['Long']>;
};

export type ActionItem = {
  __typename?: 'ActionItem';
  action_key: Scalars['String'];
  action_name?: Maybe<Scalars['String']>;
};

export type ActionList = {
  __typename?: 'ActionList';
  list?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AppConfig = {
  __typename?: 'AppConfig';
  allow_list?: Maybe<Scalars['String']>;
  app_cn_name: Scalars['String'];
  app_id: Scalars['String'];
  app_name: Scalars['String'];
  atta_config?: Maybe<AttaConfig>;
  filter_config?: Maybe<Array<Filter>>;
  other_config?: Maybe<Scalars['String']>;
  referer?: Maybe<Scalars['String']>;
  schema_config?: Maybe<SchemaConfig>;
  zhiyan_config?: Maybe<ZhiyanConfig>;
};

export type AppConfigExternal = {
  __typename?: 'AppConfigExternal';
  allow_list?: Maybe<Scalars['String']>;
  app_cn_name: Scalars['String'];
  app_id: Scalars['String'];
  app_name: Scalars['String'];
  filter_config?: Maybe<Array<Filter>>;
  other_config?: Maybe<Scalars['String']>;
  referer?: Maybe<Scalars['String']>;
  schema_config?: Maybe<SchemaConfig>;
};

export type AttaConfig = {
  __typename?: 'AttaConfig';
  attaid?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type Field = {
  field?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Filter = {
  __typename?: 'Filter';
  component?: Maybe<Scalars['String']>;
  componentProps?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  operator?: Maybe<Operator>;
};

export type FilterField = {
  field?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  report?: Maybe<Scalars['Boolean']>;
};


export type MutationReportArgs = {
  params: ReportInput;
};

export enum Operator {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Like = 'LIKE',
  Lt = 'LT',
  Lte = 'LTE',
  Neq = 'NEQ',
  Nlike = 'NLIKE',
  Norange = 'NORANGE',
  Range = 'RANGE'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  page?: Maybe<Scalars['Int']>;
  page_size?: Maybe<Scalars['Int']>;
  total_num?: Maybe<Scalars['Int']>;
  total_page?: Maybe<Scalars['Int']>;
};

export type PathList = {
  __typename?: 'PathList';
  list?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Query = {
  __typename?: 'Query';
  app_config: AppConfigExternal;
  getActionList?: Maybe<ActionList>;
  getPathList?: Maybe<PathList>;
  getReportByAction?: Maybe<ReportByAction>;
  getReportByActionFunnel?: Maybe<Array<ReportByActionFunnel>>;
  getReportByPath?: Maybe<ReportByPath>;
  system: System;
};


export type QueryGetActionListArgs = {
  params: QueryInput;
};


export type QueryGetPathListArgs = {
  params: QueryInput;
};


export type QueryGetReportByActionArgs = {
  params: ReportByActionInput;
};


export type QueryGetReportByActionFunnelArgs = {
  params: ReportByActionInput;
};


export type QueryGetReportByPathArgs = {
  params: ReportByPathInput;
};

export type QueryInput = {
  end_date: Scalars['String'];
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  start_date: Scalars['String'];
  uin?: InputMaybe<Scalars['String']>;
};

export type ReportAction = {
  action: Scalars['String'];
  duration?: InputMaybe<Scalars['Long']>;
  is_global?: InputMaybe<Scalars['Boolean']>;
  other_fields?: InputMaybe<Array<Field>>;
  path: Scalars['String'];
  time: Scalars['String'];
  uin: Scalars['String'];
};

export type ReportByAction = {
  __typename?: 'ReportByAction';
  action_key: Scalars['String'];
  action_name: Scalars['String'];
  detail_list?: Maybe<Array<ReportByActionDetail>>;
  pv: Scalars['Long'];
  uv: Scalars['Long'];
};

export type ReportByActionDetail = {
  __typename?: 'ReportByActionDetail';
  date: Scalars['String'];
  pv: Scalars['Long'];
  uv: Scalars['Long'];
};

export type ReportByActionFunnel = {
  __typename?: 'ReportByActionFunnel';
  detail_list?: Maybe<Array<ReportByActionFunnelDetail>>;
  first_action_key: Scalars['String'];
  first_action_name: Scalars['String'];
  first_action_pv: Scalars['Long'];
  first_action_uv: Scalars['Long'];
  second_action_key: Scalars['String'];
  second_action_name: Scalars['String'];
  second_action_pv: Scalars['Long'];
  second_action_uv: Scalars['Long'];
};

export type ReportByActionFunnelDetail = {
  __typename?: 'ReportByActionFunnelDetail';
  date: Scalars['String'];
  first_action_pv: Scalars['Long'];
  first_action_uv: Scalars['Long'];
  second_action_pv: Scalars['Long'];
  second_action_uv: Scalars['Long'];
};

export type ReportByActionInput = {
  action: Scalars['String'];
  end_date: Scalars['String'];
  other_fields?: InputMaybe<Array<FilterField>>;
  path?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  uin?: InputMaybe<Scalars['String']>;
};

export type ReportByPath = {
  __typename?: 'ReportByPath';
  action_list?: Maybe<Array<Action>>;
  average_duration: Scalars['Long'];
  pv: Scalars['Long'];
  uv: Scalars['Long'];
};

export type ReportByPathInput = {
  end_date: Scalars['String'];
  path: Scalars['String'];
  start_date: Scalars['String'];
  uin?: InputMaybe<Scalars['String']>;
};

export type ReportInput = {
  action_list: Array<ReportAction>;
};

export type SchemaConfig = {
  __typename?: 'SchemaConfig';
  action?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  uin?: Maybe<Scalars['String']>;
};

export type System = {
  __typename?: 'System';
  user?: Maybe<SystemUser>;
};

export type SystemUser = {
  __typename?: 'SystemUser';
  allow?: Maybe<Scalars['Boolean']>;
  avatar_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ZhiyanConfig = {
  __typename?: 'ZhiyanConfig';
  dataflow_name?: Maybe<Scalars['String']>;
  projectname?: Maybe<Scalars['String']>;
  sdk_topic?: Maybe<Scalars['String']>;
  staffname?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type GetSystemUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSystemUserQuery = { __typename?: 'Query', system: { __typename?: 'System', user?: { __typename?: 'SystemUser', name?: string | null, avatar_url?: string | null, allow?: boolean | null } | null } };

export type GetAppConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppConfigQuery = { __typename?: 'Query', app_config: { __typename?: 'AppConfigExternal', other_config?: string | null, filter_config?: Array<{ __typename?: 'Filter', field?: string | null, label?: string | null, operator?: Operator | null, component?: string | null, componentProps?: string | null }> | null } };

export type GetReportByPathQueryVariables = Exact<{
  params: ReportByPathInput;
}>;


export type GetReportByPathQuery = { __typename?: 'Query', getReportByPath?: { __typename?: 'ReportByPath', pv: any, uv: any, average_duration: any, action_list?: Array<{ __typename?: 'Action', key: string, name?: string | null, pv: any, total_pv?: any | null }> | null } | null };

export type GetReportByActionQueryVariables = Exact<{
  params: ReportByActionInput;
}>;


export type GetReportByActionQuery = { __typename?: 'Query', getReportByAction?: { __typename?: 'ReportByAction', action_key: string, action_name: string, pv: any, uv: any, detail_list?: Array<{ __typename?: 'ReportByActionDetail', date: string, pv: any, uv: any }> | null } | null };

export type GetReportByActionFunnelQueryVariables = Exact<{
  params: ReportByActionInput;
}>;


export type GetReportByActionFunnelQuery = { __typename?: 'Query', getReportByActionFunnel?: Array<{ __typename?: 'ReportByActionFunnel', first_action_key: string, first_action_name: string, first_action_pv: any, first_action_uv: any, second_action_key: string, second_action_name: string, second_action_pv: any, second_action_uv: any, detail_list?: Array<{ __typename?: 'ReportByActionFunnelDetail', date: string, first_action_pv: any, first_action_uv: any, second_action_pv: any, second_action_uv: any }> | null }> | null };

export type GetPathListQueryVariables = Exact<{
  params: QueryInput;
}>;


export type GetPathListQuery = { __typename?: 'Query', getPathList?: { __typename?: 'PathList', list?: Array<string | null> | null } | null };

export type GetActionListQueryVariables = Exact<{
  params: QueryInput;
}>;


export type GetActionListQuery = { __typename?: 'Query', getActionList?: { __typename?: 'ActionList', list?: Array<string | null> | null } | null };

export type ReportMutationVariables = Exact<{
  params: ReportInput;
}>;


export type ReportMutation = { __typename?: 'Mutation', report?: boolean | null };


export const GetSystemUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSystemUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"allow"}}]}}]}}]}}]} as unknown as DocumentNode<GetSystemUserQuery, GetSystemUserQueryVariables>;
export const GetAppConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"app_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"other_config"}},{"kind":"Field","name":{"kind":"Name","value":"filter_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"component"}},{"kind":"Field","name":{"kind":"Name","value":"componentProps"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppConfigQuery, GetAppConfigQueryVariables>;
export const GetReportByPathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReportByPath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportByPathInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportByPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pv"}},{"kind":"Field","name":{"kind":"Name","value":"uv"}},{"kind":"Field","name":{"kind":"Name","value":"average_duration"}},{"kind":"Field","name":{"kind":"Name","value":"action_list"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pv"}},{"kind":"Field","name":{"kind":"Name","value":"total_pv"}}]}}]}}]}}]} as unknown as DocumentNode<GetReportByPathQuery, GetReportByPathQueryVariables>;
export const GetReportByActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReportByAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportByActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportByAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_key"}},{"kind":"Field","name":{"kind":"Name","value":"action_name"}},{"kind":"Field","name":{"kind":"Name","value":"pv"}},{"kind":"Field","name":{"kind":"Name","value":"uv"}},{"kind":"Field","name":{"kind":"Name","value":"detail_list"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"pv"}},{"kind":"Field","name":{"kind":"Name","value":"uv"}}]}}]}}]}}]} as unknown as DocumentNode<GetReportByActionQuery, GetReportByActionQueryVariables>;
export const GetReportByActionFunnelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReportByActionFunnel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportByActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportByActionFunnel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_action_key"}},{"kind":"Field","name":{"kind":"Name","value":"first_action_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_action_pv"}},{"kind":"Field","name":{"kind":"Name","value":"first_action_uv"}},{"kind":"Field","name":{"kind":"Name","value":"second_action_key"}},{"kind":"Field","name":{"kind":"Name","value":"second_action_name"}},{"kind":"Field","name":{"kind":"Name","value":"second_action_pv"}},{"kind":"Field","name":{"kind":"Name","value":"second_action_uv"}},{"kind":"Field","name":{"kind":"Name","value":"detail_list"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"first_action_pv"}},{"kind":"Field","name":{"kind":"Name","value":"first_action_uv"}},{"kind":"Field","name":{"kind":"Name","value":"second_action_pv"}},{"kind":"Field","name":{"kind":"Name","value":"second_action_uv"}}]}}]}}]}}]} as unknown as DocumentNode<GetReportByActionFunnelQuery, GetReportByActionFunnelQueryVariables>;
export const GetPathListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPathList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPathList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"list"}}]}}]}}]} as unknown as DocumentNode<GetPathListQuery, GetPathListQueryVariables>;
export const GetActionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"list"}}]}}]}}]} as unknown as DocumentNode<GetActionListQuery, GetActionListQueryVariables>;
export const ReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"report"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}]}]}}]} as unknown as DocumentNode<ReportMutation, ReportMutationVariables>;